import { render } from "./Pre.vue?vue&type=template&id=9fb93fa4"
import script from "./Pre.vue?vue&type=script&lang=js"
export * from "./Pre.vue?vue&type=script&lang=js"

import "./Pre.vue?vue&type=style&index=0&id=9fb93fa4&lang=css"

import exportComponent from "/n/www/reich-ages.rc.hms.harvard.edu/AGES/Front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__